var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { ref: "container" },
    [
      _c(
        "a-modal",
        {
          staticStyle: { top: "15%", height: "60%" },
          attrs: {
            title: _vm.title,
            width: 600,
            visible: _vm.visible,
            confirmLoading: _vm.confirmLoading,
            getContainer: () => _vm.$refs.container,
            maskStyle: { top: "93px", left: "154px" },
            wrapClassName: _vm.wrapClassNameInfo(),
            mask: _vm.isDesktop(),
            maskClosable: false,
            cancelText: "取消",
            okText: "保存",
          },
          on: { ok: _vm.handleOk, cancel: _vm.handleCancel },
        },
        [
          _c(
            "a-spin",
            { attrs: { spinning: _vm.confirmLoading } },
            [
              _c(
                "a-form",
                { attrs: { form: _vm.form } },
                [
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        labelCol: _vm.labelCol,
                        wrapperCol: _vm.wrapperCol,
                        label: "登录名称",
                      },
                    },
                    [
                      _c("a-input", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator.trim",
                            value: ["loginName", _vm.validatorRules.loginName],
                            expression:
                              "[ 'loginName', validatorRules.loginName]",
                            modifiers: { trim: true },
                          },
                        ],
                        attrs: {
                          placeholder: "请输入登录名称",
                          readOnly: !!_vm.model.id,
                          suffix: "初始密码：123456",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        labelCol: _vm.labelCol,
                        wrapperCol: _vm.wrapperCol,
                        label: "用户数量限制",
                      },
                    },
                    [
                      _c("a-input-number", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator.trim",
                            value: ["userNumLimit"],
                            expression: "[ 'userNumLimit' ]",
                            modifiers: { trim: true },
                          },
                        ],
                        staticStyle: { width: "100%" },
                        attrs: { placeholder: "请输入用户数量限制" },
                      }),
                    ],
                    1
                  ),
                  _vm.model.id
                    ? _c(
                        "a-form-item",
                        {
                          attrs: {
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            label: "租户角色",
                          },
                        },
                        [
                          _c(
                            "a-select",
                            {
                              directives: [
                                {
                                  name: "decorator",
                                  rawName: "v-decorator.trim",
                                  value: ["roleId"],
                                  expression: "[ 'roleId' ]",
                                  modifiers: { trim: true },
                                },
                              ],
                              staticStyle: { width: "100%" },
                              attrs: { placeholder: "请选择租户角色" },
                            },
                            _vm._l(_vm.tenantRoleList, function (item, index) {
                              return _c(
                                "a-select-option",
                                { key: index, attrs: { value: item.id } },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(item.name) +
                                      "\n            "
                                  ),
                                ]
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.model.id
                    ? _c(
                        "a-form-item",
                        {
                          attrs: {
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            label: "租户类型",
                          },
                        },
                        [
                          _c(
                            "a-select",
                            {
                              directives: [
                                {
                                  name: "decorator",
                                  rawName: "v-decorator.trim",
                                  value: ["type"],
                                  expression: "[ 'type' ]",
                                  modifiers: { trim: true },
                                },
                              ],
                              staticStyle: { width: "100%" },
                              attrs: { placeholder: "请选择租户类型" },
                            },
                            [
                              _c("a-select-option", { attrs: { value: "0" } }, [
                                _vm._v("试用租户"),
                              ]),
                              _c("a-select-option", { attrs: { value: "1" } }, [
                                _vm._v("付费租户"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        labelCol: _vm.labelCol,
                        wrapperCol: _vm.wrapperCol,
                        label: "到期时间",
                      },
                    },
                    [
                      _c("j-date", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator.trim",
                            value: ["expireTime"],
                            expression: "[ 'expireTime' ]",
                            modifiers: { trim: true },
                          },
                        ],
                        staticStyle: { width: "100%" },
                        attrs: {
                          placeholder: "请选择到期时间",
                          "show-time": true,
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        labelCol: _vm.labelCol,
                        wrapperCol: _vm.wrapperCol,
                        label: "备注",
                      },
                    },
                    [
                      _c("a-textarea", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator.trim",
                            value: ["remark"],
                            expression: "[ 'remark' ]",
                            modifiers: { trim: true },
                          },
                        ],
                        attrs: { rows: 2, placeholder: "请输入备注（微信号）" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }